import { Locale as VantLocale } from 'vant';
import zhCN from 'vant/es/locale/lang/zh-CN';
import enUS from 'vant/es/locale/lang/en-US';
import { messages } from '@/i18n/messages/index.js';

export const APP_LANGUAGE_OPTIONS = [
  { key: 'zh-CN', label: '简体中文' },
  { key: 'zh-HK', label: '繁體中文' },
  { key: 'en-US', label: 'English' },
  { key: 'vi-VN', label: 'Tiếng Việt' },
  { key: 'id-ID', label: 'Bahasa Indonesia' },
  { key: 'ms-MY', label: 'Bahasa Melayu' }
];

const SUPPORTED_VANT_LOCALES = {
  'zh-CN': zhCN,
  'zh-HK': zhCN,
  'en-US': enUS,
  'vi-VN': enUS,
  'id-ID': enUS,
  'ms-MY': enUS
};

export function resolveLocale(locale) {
  return messages[locale] ? locale : 'zh-CN';
}

export function applyAppLocale(i18n, locale) {
  const nextLocale = resolveLocale(locale);
  i18n.global.locale.value = nextLocale;
  VantLocale.use(nextLocale, SUPPORTED_VANT_LOCALES[nextLocale] || zhCN);
  return nextLocale;
}
